import { traditionalReadingOrderBibleArray } from "./BibleData";
import { chronologicalReadingOrderBibleArray } from "./BibleData_chronological";
import { historicalReadingOrderBibleArray } from "./BibleData_historical";

export const READING_ORDERS = {
  traditional: traditionalReadingOrderBibleArray,
  chronological: chronologicalReadingOrderBibleArray,
  historical: historicalReadingOrderBibleArray,
};
